import { AbstractAccountDataCommand } from "./abstractAccountDataCommand";

export class AccountEntitiesCommand extends AbstractAccountDataCommand {
  classNames: Array<string> = new Array<string>();
}